module.exports = __webpack_public_path__ + "assets/IDCardA.fcec1bd0.svg";